import React from 'react'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import moment from 'moment'
import { rem } from 'polished'
import styled from 'styled-components'

const CircularWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${rem(68)};
  height: ${rem(68)};
  background-color: white;
  border-radius: 50%;
`

const EasterTakeover: App.SiteTakeover = {
  id: 'easter2025',
  startDate: moment('2025-04-16T09:00:00+1100'),
  endDate: moment('2025-04-30T23:59:00+1100'),
  brands: new Set(['luxuryescapes']),
  regions: new Set(['SG', 'HK', 'MY', 'ZA']),
  palette: 'inverse',
  heroCarousel: {
    title: <Group direction="horizontal" gap={24} verticalAlign="center">
      <CircularWrapper>
        <ResponsiveImage id="08l1g2hblaw0taboz1sh" quality="good" width={48} />
      </CircularWrapper>
      <VerticalSpacer gap={2}>
        <Heading variant="heading2" colour="exclusive">Exclusive Easter Escapes</Heading>
        <BodyText variant="large" colour="neutral-one">LIMITED TIME ONLY</BodyText>
      </VerticalSpacer>
    </Group>,
    filters: true,
    verticals: ['home'],
  },
  verticals: new Set(['home']),
  backgroundElement: () => null,
}

export default EasterTakeover
